import type { FC } from "react";

import type { RedirectionLinkCardProps } from "@ui/components/RedirectionLinkCard";
import { RedirectionLinkCard } from "@ui/components/RedirectionLinkCard";

import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";

import styles from "./List.module.scss";

export type ListProps = {
  items: RedirectionLinkCardProps[];
};

export const List: FC<ListProps> = ({ items }) => {
  return (
    <ul className={styles.list}>
      {items?.map(({ title, link, isArrowHidden }) => {
        const dispatchGTMEvent = () => {
          dispatchTrackingEvent(TrackingEvents.TrackingMenuNavigationClick, { menu_link: title });
        };

        return (
          <li key={title} className={styles.item}>
            <RedirectionLinkCard
              variant="list"
              title={title}
              link={link ?? ""}
              onClick={dispatchGTMEvent}
              isArrowHidden={isArrowHidden}
            />
          </li>
        );
      })}
    </ul>
  );
};
